import HojaMarcaciones from 'components/UsuarioGeneral/Hoja Marcaciones/HojaMarcaciones'
import React from 'react'

export default function ConsultaHojaPorUsuario() {
    return (
        <>
            <HojaMarcaciones
                ingresaIdentificacion={true}
            />
        </>

    )
}
